import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function WhatYoullLearn() {
  const learnings = ['Where funding actually comes from (grants, programs, partnerships)', 'How to position yourself to be taken seriously', 'What rooms you should be in (and how to get there)', 'The biggest mistakes women make when trying to get funded', "How to move from 'idea' to 'fundable'"];
  return <section className="py-24 bg-gradient-to-b from-[#2A0F24] to-maroon relative overflow-hidden" data-id="element-184">
      {/* Subtle glow */}
      <div className="absolute top-[-10%] right-[-10%] w-[40%] h-[40%] bg-blush/5 blur-[100px] rounded-full pointer-events-none" data-id="element-185"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-186">
        <FadeIn data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-white" data-id="element-188">
            Inside Our First Call, We'll Cover:
          </h2>
        </FadeIn>

        <StaggerContainer className="space-y-5" data-id="element-189">
          {learnings.map((item, index) => <StaggerItem key={index} className="flex items-start bg-white/[0.06] backdrop-blur-sm p-6 md:p-8 rounded-xl border border-blush/15 hover:border-blush/30 hover:bg-white/[0.09] transition-all duration-300" data-id="element-190">
              <div className="bg-blush/20 p-2 rounded-full mr-6 flex-shrink-0 mt-1" data-id="element-191">
                <Check className="w-6 h-6 text-blush" data-id="element-192" />
              </div>
              <p className="text-lg md:text-xl text-cream/90 leading-relaxed" data-id="element-193">
                {item}
              </p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}